import { createAction, handleActions } from 'redux-actions'

const setFilters = createAction('SCREENS/SUB_PROJECT/OVERVIEW/SET_FILTERS')
const setFilter = createAction('SCREENS/SUB_PROJECT/OVERVIEW/SET_FILTER')
const resetFilters = createAction('SCREENS/SUB_PROJECT/OVERVIEW/RESET_FILTERS')

const defaultState = {
  completionStatuses: [],
}

const reducer = handleActions(
  {
    [setFilters]: (state, { payload }) => payload,
    [setFilter]: (state, { payload }) => ({ ...state, [payload.field]: payload.value }),
    [resetFilters]: () => defaultState,
  },
  defaultState,
)

export { setFilters, setFilter, resetFilters, reducer }
